import { render, staticRenderFns } from "./CarritoComponent.vue?vue&type=template&id=5c9de492&scoped=true"
import script from "./CarritoComponent.vue?vue&type=script&lang=js"
export * from "./CarritoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9de492",
  null
  
)

export default component.exports